import React, { Component } from "react";

import { Typography } from "@mui/material";
import Widget from "../common/Widget";
import { WidgetMapping, WidgetProps } from "./config";
import { WidgetConfigs } from "../SetUp/config";

class WidgetCard extends Component {
    state ={
    }

    render() {
        const WidgetComponent = WidgetMapping[this.props.widget.id];
        return <React.Fragment>
            <div  className="myOdu__widgetDragAndDrop">
                <WidgetComponent widget={this.props.widget} {...this.props} {...WidgetProps[this.props.widget.id]}/>
            </div>
        </React.Fragment>
    }
}

export default WidgetCard;